export const screenerIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Screener Results report is where you can view your students\' screener results. This report provides insight into the extent to which students have developed automatic word recognition sufficient to support fluency.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade or class.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Screener Results.'
  },
  {
    element: '.screener-report-chart',
    intro: 'See the three risk categories that students are sorted into: High Risk, Some Risk, and Proficient. The WordFlight Screener estimates the student’s performance on the WordFlight Diagnostic and provides a risk category. '
      + 'See the chart and graphic for the number of students in each of the three risk categories. Some Risk and High Risk students are recommended as excellent candidates for WordFlight. Borderline proficient students may also '
      + 'benefit from using WordFlight. Borderline proficiency for grades 2-4 is the range of 400-450. Borderline proficiency for grades 5+ is the range of 300- 350.'
  },
  {
    element: '.status-totals-section',
    intro: 'See the number of students who have not started the Screener, have started the Screener, have skipped the Screener, and the total number of students who were enrolled in the Screener.',
  },
  {
    element: '#screener-table thead',
    intro: 'See the results for all of the students who have been enrolled in the WordFlight Screener. You can see their name, grade, results, date started, date completed, and percent complete. WordFlight recommends students complete the Screener in a single session.'
  },
  {
    element: '#results-th',
    intro: 'The WordFlight Screener estimates the student\'s performance on the WordFlight Diagnostic, which has a scale of 0 to 600. Screener results are presented in a confidence interval of 60 scale points. See the color of the score to see which risk category the student is in.'
  },
];
